import {Directive,  HostListener, Input} from '@angular/core';

@Directive({
    selector: '[allowOnly]'
})
export class AllowOnly  {

    @Input() allowOnly: string;
    private pattern: RegExp;

    @HostListener('keydown', ['$event'])
    onKeyDown(e: KeyboardEvent) {
        /**
         * Allow backspace,left,right and delete
         */
        if (!this.pattern) {
            this.pattern = new RegExp(`^${this.allowOnly}*$`);
        }

        if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) ||
            // Allow: Ctrl+C
            (e.keyCode == 67 && e.ctrlKey === true) ||
             // Allow: Ctrl+V
            (e.keyCode == 86 && e.ctrlKey === true) ||
            // Allow: Ctrl+X
            (e.keyCode == 88 && e.ctrlKey === true) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }

        // Ensure that it is a number and is in range
        if (!this.pattern.test(e.key)) {
            e.preventDefault();
        }
    }
}
